var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _rect3, _ellipse, _path9, _rect4, _path10, _path11, _ellipse2, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYodaHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0yh{fill:#303031;}\r\n\t.st1yh{fill:#515051;}\r\n\t.st2yh{fill:#7B7B7C;}\r\n\t.st3yh{fill:#1F1F21;}\r\n\t.st4yh{fill:#191919;}\r\n\t.st5yh{fill:#7C7875;}\r\n\t.st6yh{fill:#161616;}\r\n\t.st7yh{fill:#0E0E0E;}\r\n\t.st8yh{fill:#89898C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0yh",
    d: "M8.5,197c2.1,1.3,6.5,3.5,11.6,3.2c2.9-0.1,5.9-1.1,7.4-2c0.1,0,2.1-1.3,2.1-1.3c0-2.5,0.1-5,0.1-7.4 c-7-0.1-14.1-0.1-21.1-0.2C8.6,191.8,8.5,194.4,8.5,197z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1yh",
    d: "M29.7,191.7c-2.6,1.5-6.8,3.3-12.1,2.8c-3.8-0.3-6.9-1.7-9.1-3.1c0-0.5,0-0.9,0-1.4c2.4,1.3,6.1,2.7,10.6,2.7 c4.5,0,8.2-1.4,10.6-2.7C29.7,190.6,29.7,191.1,29.7,191.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2yh",
    d: "M8.5,123.3h21.2v66.8c-2.2,1.4-5.9,3.2-10.5,3.3c-4.7,0-8.4-1.8-10.7-3.3C8.5,167.8,8.5,145.6,8.5,123.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0yh",
    d: "M19.1,186.3L19.1,186.3c-3.1,0-5.6-2.5-5.6-5.6v-41.2c0-3.1,2.5-5.6,5.6-5.6h0c3.1,0,5.6,2.5,5.6,5.6v41.2 C24.7,183.8,22.2,186.3,19.1,186.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0yh",
    d: "M8,184L8,184c-0.8,0-1.5-0.7-1.5-1.5v-48.6c0-0.8,0.7-1.5,1.5-1.5h0c0.8,0,1.5,0.7,1.5,1.5v48.6 C9.5,183.3,8.9,184,8,184z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0yh",
    d: "M30.3,184.4L30.3,184.4c-0.8,0-1.5-0.7-1.5-1.5v-48.6c0-0.8,0.7-1.5,1.5-1.5h0c0.8,0,1.5,0.7,1.5,1.5v48.6 C31.7,183.7,31.1,184.4,30.3,184.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3yh",
    d: "M8.9,126.2c-2.1,0-4.2,0-6.3-0.1C2.3,116,2,106,1.8,95.9c-0.6-0.1-1.2-0.3-1.8-0.4c0-5,0-10.1,0-15.1 c2.5,0,5,0,7.6,0C8,95.7,8.5,110.9,8.9,126.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 80.1,
    className: "st4yh",
    width: 24.3,
    height: 46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 77.9,
    className: "st4yh",
    width: 22.4,
    height: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4yh",
    d: "M8,128.4c3.2,0.7,6.9,1.2,11,1.2c4.2,0,7.9-0.5,11.2-1.2c0-1.3,0-2.6,0-4c-7.4,0-14.8,0-22.2,0 C8,125.7,8,127.1,8,128.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 82.5,
    className: "st3yh",
    width: 7.3,
    height: 13.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5yh",
    cx: 19.8,
    cy: 89.1,
    rx: 1,
    ry: 1.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6yh",
    d: "M28,27.1c-5.9,0.3-11.9,0.5-17.8,0.8c0-0.7,0-1.5,0-2.2c-0.1,0-0.7-0.4-0.9-1.5c-0.2-1,0.1-2.2,0.6-2.8 c0.9-0.5,1.8-1,2.8-1.4c2.6-1,4.9-1.2,6.7-1.1c2.8,1.4,5.6,2.8,8.5,4.2C27.9,24.4,27.9,25.8,28,27.1z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1,
    y: 34.4,
    className: "st7yh",
    width: 1.9,
    height: 12.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8yh",
    d: "M31.6,56h-0.4c-1,0-1.8-0.8-1.8-1.8v-6c0-1,0.8-1.8,1.8-1.8h0.4c1,0,1.8,0.8,1.8,1.8v6 C33.4,55.2,32.6,56,31.6,56z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8yh",
    d: "M33.8,55.5L33.8,55.5c-0.2,0-0.4-0.2-0.4-0.4v-7.2c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.2,0.4,0.4v7.2 C34.2,55.4,34,55.5,33.8,55.5z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8yh",
    cx: 34.3,
    cy: 51.5,
    rx: 0.7,
    ry: 1.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4yh",
    d: "M26.1,34.6c0-1.4,0-2.8,0-4.1c0.1-0.3,0.3-0.8,0.6-1.2c0.4-0.5,0.7-0.7,0.9-0.8c0-0.5,0.1-1.1,0.1-1.6 c-2.6-1.1-6.5-2.2-11.2-1.4c-2.5,0.5-4.7,1.4-6.5,2.4c0,0.3,0,0.6,0.1,0.7c0.2,0.7,0.8,1.1,1.4,1c0.1,0.3,0.2,0.5,0.4,0.8 c0,1.2,0,2.3,0,3.5C16.7,34.1,21.4,34.3,26.1,34.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2yh",
    d: "M29.7,77.9H8.5c0-14.6,0-29.2,0-43.8c2.5-1.2,5.9-2.4,10-2.5c4.6-0.1,8.4,1.1,11,2.3 C29.6,48.6,29.7,63.3,29.7,77.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2yh",
    d: "M28.3,34.8c-0.1-0.6-0.1-1.5,0-2.5c0.1-1.1,0.4-2,0.6-2.5c0.3-0.2,1-0.6,1.5-1.8c0.3-0.7,0.5-1.4,0.6-1.9 c0-7.4,0-14.9,0-22.3c-0.1-0.5-0.5-1.7-1.2-2.6c-1.2-1.4-2.6-1-2.8-0.9c-0.7,0.4-1.6,0.7-2.5,1c-1,0.3-2,0.4-2.8,0.4 c-0.4,0.1-1.1,0.4-1.8,1.1c-1.3,1.4-1.8,3.5-2,4.2c-0.3,0.8-1.2,4.2-0.5,8.2c0.6,3.4,1.9,5.4,2.4,6.1c0.6,0.4,1.2,0.8,1.9,1.2 c2.1,1.3,4.1,1.9,5.8,2.3c-0.1,3-0.2,6-0.3,8.9C27.6,34.2,27.9,34.5,28.3,34.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYodaHilt);
export default __webpack_public_path__ + "static/media/yoda-hilt.78d7eb29.svg";
export { ForwardRef as ReactComponent };